<template>
  <div class="breadcrumbs">
    <MessagePopup v-if="showTimedOut" v-model="showTimedOut"></MessagePopup>
    <div v-if="loading === 'Running'" 
      class="position-absolute spinner-overview-wrap">
      <spinner></spinner>
    </div>
  </div>
</template>
<script>
import MessagePopup from '@/components/MessagePopup'
import Spinner from '@/components/spinner'
import { RunStates } from '@/store/runStates'
export default {
  name: 'ResultUpdates',
  components: { MessagePopup, Spinner },
  data() {
    return {
      showTimedOut: false
    }
  },
  computed: {
    searchWord() {
      return this.$store.state.soundplayCallText
    },
    charuzitSearchWord() {
      return this.$store.state.textForCharuzitApiCall
    },
    nakdanWordsArrayFromState() {
      return this.$store.state.soundplayResults
    },
    loading() {
      return this.$store.state.charuzitApiState
    },
    modeWord() {
      return this.$store.state.searchModel === 'rhyme' ? 'חרוז' :
        this.$store.state.searchModel === 'xxsonance' ? 'מצלול' :
          this.$store.state.searchModel === 'alliteration' ? 'אליטרציה' :
            'תבנית מילה'
    },
  },
  watch: {
    loading() {
      if (this.loading === RunStates.COMPLETE) {
        document.title = this.modeWord + ' למילה ' + this.charuzitSearchWord + ' - החרוזית של דיקטה'
      } else if (this.loading === 'Timed out' || this.loading === 'Failed') {
        this.showTimedOut = true;
      }
    }
  },
  //link to home page, link to unvocalized, link to vocalized 
  /*
  ,{
              "@type": "ListItem",
              "position": 3,
              "name": '${this.nakdanWordsArrayFromState[0]}',
              "item": 'https://wordplay.dicta.org.il?search=${this.nakdanWordsArrayFromState[0]}'
          }
  */
  head: {
    script: function () {
      if (this.searchWord !== '') {
        return [
          {
            t: 'application/ld+json', i: `
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "חרוזים",
              "item": "https://wordplay.dicta.org.il"
          },{
              "@type": "ListItem",
              "position": 2,
              "name": '${this.searchWord}',
              "item":  'https://wordplay.dicta.org.il?search=${this.searchWord}'
          }]
        }`
          },
        ]
      } else {
        if (this.charuzitSearchWord) {
          return [
            {
              t: 'application/ld+json', i: `
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "חרוזים",
              "item": "https://wordplay.dicta.org.il"
          },{
              "@type": "ListItem",
              "position": 2,
              "name": '${this.charuzitSearchWord}',
              "item": 'https://wordplay.dicta.org.il?search=${this.charuzitSearchWord}'
          }]
          }`

            },
          ]
        }
      }
    }
  }
}
</script>